import { createElement, PropTypes } from 'rlink-react';
import {ContentImg} from 'rlink-repos/content-components';
import ContentSource from 'rlink-repos/components/ContentSource';

export default function Franchise ({data, itemNumber}) {
  return (
    <div id={`game-${itemNumber}`} className={`views-row views-row-${itemNumber} ${(itemNumber % 2 === 0) ? 'views-row-even' : 'views-row-odd'} small-12 column`}>
      <article className={`node node-game node-promoted node-teaser ${(itemNumber % 2 === 0) ? 'even' : 'odd'} row`}>
        <div className="image-column small-12 column parallax">
          <div className="field field-name-field-images field-type-image field-label-hidden field-wrapper">
            <ul className="field-items">
              {data.parallaxImages.map((image, index) => (
                <li key={`${data.title}-image-${image.imagePath}`} className={`field-item ${(index % 2 === 0) ? 'even' : 'odd'}`}>
                  <picture>
                    <source srcSet="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" media="(max-width: 40em)" />
                    <ContentImg src={image.imagePath} />
                  </picture>
                </li>
              ))}
            </ul>
          </div>
          <div className="image">
            <picture>
              <ContentSource src={data.mobileImagePath} media="(max-width: 40em)" />
              <source srcSet="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" media="(max-width: 64em)" />

              <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt="" title="" />
            </picture>
          </div>
          {data.quote
            && (
              <blockquote>
                <div className="field field-name-field-quote field-type-text field-label-hidden field-wrapper">{`“${data.quote}”`}</div>
                <cite>
                  <div className="field field-name-field-quote-author field-type-link-field field-label-hidden field-wrapper">
                    <a href={data.quoteLink} target="_blank">{data.quoteAuthor}</a>
                  </div>
                </cite>
              </blockquote>
            )
          }
        </div>
        <div className="content-column small-12 large-5 column">
          <h2 className="node-title">{data.title}</h2>
          <div className="body text-secondary">
            <div className="body text-secondary">
              {data.games.length > 0
                && (
                  <div>
                    <h5>Games in the Franchise</h5>
                    <ul>
                      {data.games.map(item =>
                        <li key={item.game}>{item.game}</li>
                      )}
                    </ul>
                  </div>
                )
              }
              <h5>About the Franchise</h5>
              <div dangerouslySetInnerHTML={{__html: data.description}} />
            </div>
          </div>
          <div className="field field-name-field-external-url field-type-link-field field-label-hidden field-wrapper">
            <a href={data.link} target="_blank" className="button large white">Visit Website</a>
          </div>
          {(data.esrb && data.esrb !== '')
            && (
              <footer>
                <div className="field field-name-field-legal field-type-text-with-summary field-label-hidden legal_sub field-wrapper">{`ESRB Rating: ${data.esrb}`}</div>
              </footer>
            )
          }
        </div>
      </article>
    </div>
  );
}

Franchise.propTypes = {
  data: PropTypes.shape({
    games: PropTypes.arrayOf(PropTypes.shape({game: PropTypes.string})),
    priority: PropTypes.number,
    quoteAuthor: PropTypes.string,
    parallaxImages: PropTypes.arrayOf(PropTypes.shape({imagePath: PropTypes.string})),
    quoteLink: PropTypes.string,
    title: PropTypes.string,
    link: PropTypes.string,
    quote: PropTypes.string,
    description: PropTypes.string,
    mobileImagePath: PropTypes.string,
    esrb: PropTypes.string,
  }),
  itemNumber: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/Franchises/Franchise.jsx